export default __webpack_public_path__ + "static/media/fuse_background_img.a194088d.png";